var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"phone-input"},[_c('input',_vm._b({ref:"input",staticClass:"phone-input__input",class:{
      'error': _vm.errorText
    },on:{"change":_vm.onChange}},'input',_vm.$attrs,false)),_vm._v(" "),(_vm.errorText)?_c('div',{staticClass:"phone-input__error"},[_vm._v("\n    "+_vm._s(_vm.errorText)+"\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }